
import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import styles from './ConfirmDeleteModal.mod.scss';



const ConfirmDeleteModal = forwardRef(({ open, onCancel, onConfirm, className, sampleCount, imageUrl, isCreabots, darktheme }, ref) => {
  const intl = useIntl();
  if (!open) return null;
  return (
    <div className={`${(!isCreabots && !darktheme) ? 'theme-aula' : ''} ${styles.confirmModalOverlay}`}>
      <div className={styles.confirmModal} ref={ref}>
        <div className={styles.headerGroup}>
          <div className={styles.confirmTitle}>
            {intl.formatMessage({ id: 'machineLearning.confirmDeleteModal.title' }, { className })}
          </div>
          <div className={styles.confirmSubtitle}>
            {intl.formatMessage({ id: 'machineLearning.confirmDeleteModal.subtitle' })}
          </div>
        </div>
        <div className={styles.classCardRow}>
          <img className={styles.classCardImg} src={imageUrl} alt={className} />
          <div className={styles.classCardInfo}>
            <div className={styles.classCardName}>{className}</div>
            <div className={styles.classCardSamples}>
              <span className={styles.classCardSamplesLabel}>
                {intl.formatMessage({ id: 'machineLearning.confirmDeleteModal.samplesLabel' })}
              </span>&nbsp;{sampleCount}
            </div>
          </div>
        </div>
        <div className={styles.confirmActions}>
          <div className={styles.buttonGroup}>
            <button className={styles.cancelBtn} onClick={onCancel}>
              {intl.formatMessage({ id: 'machineLearning.confirmDeleteModal.cancel' })}
            </button>
            <button className={styles.deleteBtn} onClick={onConfirm}>
              {intl.formatMessage({ id: 'machineLearning.confirmDeleteModal.delete' })}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ConfirmDeleteModal;
